export default "__VITE_ASSET__Bv5alTte__"